var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSealok16(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-224)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 224,
    y: -8.8818e-16,
    width: 16,
    height: 16,
    fill: "none",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "translate(64,2)",
    d: "m168-2c-1.1153-1e-7 -1.4598 1.5615-2.4902 1.9883-1.0304 0.4268-2.3774-0.43316-3.166 0.35547-0.78863 0.78862 0.0713 2.1356-0.35547 3.166-0.4268 1.0304-1.9883 1.375-1.9883 2.4902 0 1.1153 1.5615 1.4598 1.9883 2.4902s-0.43316 2.3774 0.35547 3.166c0.78862 0.78862 2.1356-0.07133 3.166 0.35547 1.0304 0.4268 1.375 1.9883 2.4902 1.9883 0.6181 0 1-0.48022 1.3926-0.98047l-1.2871-2.5723c-0.33239-0.66495 0.15113-1.4472 0.89453-1.4473h2c0.34896 0.014463 0.66509 0.20992 0.83398 0.51562l1.2461-2.9102c0.1579-0.36769 0.51976-0.60586 0.91992-0.60547h2c0-1.1153-1.5615-1.4598-1.9883-2.4902s0.43316-2.3774-0.35547-3.166c-0.78862-0.78863-2.1356 0.071332-3.166-0.35547-1.0304-0.4268-1.375-1.9883-2.4902-1.9883z",
    fill: "#ff8080",
    style: {
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m232 3c-2.7496 0-5 2.2504-5 5 0 2.7496 2.2504 5 5 5 0.12626 0 0.25102-0.0063 0.375-0.01563l-0.26953-0.53711c-0.07336-0.14675-0.10562-0.29874-0.10547-0.44726a4 4 0 0 1-4-4 4 4 0 0 1 4-4 4 4 0 0 1 4 4 4 4 0 0 1-1.3555 3h0.35547c0.27686 0.01148 0.53255 0.1378 0.71094 0.3418 0.1585-0.17574 0.30481-0.36182 0.4375-0.55859l0.73633-1.7227c0.07474-0.34229 0.11523-0.69672 0.11523-1.0605 0-2.7496-2.2504-5-5-5z",
    color: "#000000",
    fill: "#fff",
    strokeLinecap: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m238 9-2.0762 4.8457-0.92383-1.8457h-2l2 4h2l3-7z",
    color: "#000000",
    fill: "#008000",
    strokeLinejoin: "round",
    style: {
      InkscapeStroke: "none",
      paintOrder: "markers stroke fill"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSealok16);
export default __webpack_public_path__ + "static/media/seal.ok.16.43443281be2b1b60d0748a40b4bcda59.svg";
export { ForwardRef as ReactComponent };